module.exports = __webpack_public_path__ + "img/o6.86506a18.png";